
module.exports = { 
      attributes: {},
    
      body: "Multicultural and refugee health services support people who may not have English as a first language to access health service and promote good health and wellbeing.\n",
    
      meta: {"resourcePath":"/home/vsts/work/1/s/src/tenants/amh/content/categoryDescription/default/multi-cultural-and-refugee-health.md"},
     }